module.exports = __webpack_public_path__ + "img/Screenshot 2566-07-26 at 15.09.36@2x.e89cfcab.png";